import { BASE } from './index';
import axios from './http';
const ban = {
    // 供应商拉黑列表列表
    blacklistmemberlist: params => axios.post(`${BASE.PRO1}/supplier/blacklist/member/list`, params ),
    // 供应商拉黑列表列表
    searchdata: params => axios.post(`${BASE.PRO1}/supplier/blacklist/search/data`, params ),
    // 供应商拉黑列表列表审核
    memberaudit: params => axios.post(`${BASE.PRO1}/supplier/blacklist/member/audit`, params )
    
 
};

export default ban;
